import { render, staticRenderFns } from "./OrderSummaryCard.vue?vue&type=template&id=2f9423b3&scoped=true&"
import script from "./OrderSummaryCard.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryCard.vue?vue&type=style&index=0&id=2f9423b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9423b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
